/* ==========================================================================
   ODYSSÉE PRESTIGE — THEME.JS
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Helpers ---------- */
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ---------- Mobile menu ---------- */
  var menuToggle = qs('[data-menu-toggle]');
  var menuClose = qs('[data-menu-close]');
  var mobileMenu = qs('[data-mobile-menu]');
  var menuOverlay = qs('[data-menu-overlay]');

  function openMenu() {
    mobileMenu && mobileMenu.classList.add('is-open');
    menuOverlay && menuOverlay.classList.add('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileMenu && mobileMenu.classList.remove('is-open');
    menuOverlay && menuOverlay.classList.remove('is-open');
    menuToggle && menuToggle.setAttribute('aria-expanded', 'false');
    document.documentElement.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', openMenu);
  menuClose && menuClose.addEventListener('click', closeMenu);
  menuOverlay && menuOverlay.addEventListener('click', closeMenu);

  /* ---------- Search drawer ---------- */
  var searchToggle = qs('[data-search-toggle]');
  var searchClose = qs('[data-search-close]');
  var searchDrawer = qs('[data-search-drawer]');
  var searchOverlay = qs('[data-search-overlay]');
  var searchInput = qs('[data-search-input]');

  function openSearch() {
    searchDrawer && searchDrawer.classList.add('is-open');
    searchOverlay && searchOverlay.classList.add('is-open');
    setTimeout(function () { searchInput && searchInput.focus(); }, 250);
  }
  function closeSearch() {
    searchDrawer && searchDrawer.classList.remove('is-open');
    searchOverlay && searchOverlay.classList.remove('is-open');
  }
  searchToggle && searchToggle.addEventListener('click', openSearch);
  searchClose && searchClose.addEventListener('click', closeSearch);
  searchOverlay && searchOverlay.addEventListener('click', closeSearch);

  /* ---------- Cart drawer ---------- */
  var cartDrawer = qs('[data-cart-drawer]');
  var cartOverlay = qs('[data-cart-overlay]');
  var cartClose = qs('[data-cart-close]');
  var cartToggleBtns = qsa('[data-cart-toggle]');
  var cartCountEls = qsa('[data-cart-count]');
  var drawerEnabled = document.body.dataset.cartDrawerEnabled !== 'false';

  function openCart() {
    cartDrawer && cartDrawer.classList.add('is-open');
    cartOverlay && cartOverlay.classList.add('is-open');
  }
  function closeCart() {
    cartDrawer && cartDrawer.classList.remove('is-open');
    cartOverlay && cartOverlay.classList.remove('is-open');
  }
  cartToggleBtns.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      if (cartDrawer) {
        e.preventDefault();
        openCart();
      }
    });
  });
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  /* ---------- Escape key closes any open panel ---------- */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeMenu();
      closeSearch();
      closeCart();
    }
  });

  /* ---------- Add to cart (AJAX) ---------- */
  function updateCartCount(count) {
    cartCountEls.forEach(function (el) {
      el.textContent = count;
      el.setAttribute('data-cart-count', count);
    });
  }

  function refreshCartDrawer() {
    fetch('/?section_id=cart-drawer')
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var newDrawer = doc.querySelector('[data-cart-drawer]');
        if (newDrawer && cartDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
        }
      })
      .catch(function () {});
  }

  qsa('form[action*="/cart/add"]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      if (!drawerEnabled) return; // let it submit normally
      e.preventDefault();
      var formData = new FormData(form);
      var submitBtn = form.querySelector('[type="submit"]');
      if (submitBtn) { submitBtn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
        .then(function (res) { return res.json(); })
        .then(function () {
          return fetch('/cart.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          updateCartCount(cart.item_count);
          refreshCartDrawer();
          openCart();
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (submitBtn) { submitBtn.disabled = false; }
        });
    });
  });

  /* ---------- Quantity selector (+/-) ---------- */
  function initQuantitySelectors(root) {
    qsa('[data-quantity-selector]', root).forEach(function (wrapper) {
      if (wrapper.dataset.qtyBound) return;
      wrapper.dataset.qtyBound = 'true';

      var input = qs('[data-quantity-input]', wrapper);
      var decreaseBtn = qs('[data-quantity-decrease]', wrapper);
      var increaseBtn = qs('[data-quantity-increase]', wrapper);
      if (!input) return;

      decreaseBtn && decreaseBtn.addEventListener('click', function () {
        var min = parseInt(input.min, 10) || 0;
        var value = parseInt(input.value, 10) || min;
        input.value = Math.max(min, value - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      increaseBtn && increaseBtn.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || 0;
        input.value = value + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  }
  initQuantitySelectors(document);

  /* ---------- Cart page (AJAX quantity + remove) ---------- */
  var cartPageForm = qs('[data-cart-page]');

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function setLineBusy(line, busy) {
    if (!line) return;
    line.classList.toggle('is-updating', busy);
    qsa('button, input', line).forEach(function (el) { el.disabled = busy; });
  }

  function updateCartTotals(cart) {
    updateCartCount(cart.item_count);
    var subtotalEls = qsa('[data-cart-subtotal]');
    subtotalEls.forEach(function (el) { el.textContent = formatMoney(cart.total_price); });

    if (cart.item_count === 0 && cartPageForm) {
      var wrapper = qs('[data-cart-page-content]');
      if (wrapper) {
        var allProductsUrl = wrapper.getAttribute('data-all-products-url') || '/collections/all';
        wrapper.innerHTML =
          '<div class="cart-page__empty">' +
          '<p>Votre panier est vide.</p>' +
          '<a href="' + allProductsUrl + '" class="btn btn--outline">Découvrir la collection</a>' +
          '</div>';
      }
    }
  }

  function changeCartLine(key, quantity, line) {
    setLineBusy(line, true);
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var item = cart.items.filter(function (i) { return i.key === key; })[0];

        if (!item) {
          if (line) {
            line.classList.add('is-removing');
            setTimeout(function () { line.remove(); }, 200);
          }
        } else if (line) {
          var totalEl = qs('[data-cart-item-total]', line);
          totalEl && (totalEl.textContent = formatMoney(item.final_line_price));
          var input = qs('[data-quantity-input]', line);
          input && (input.value = item.quantity);
          setLineBusy(line, false);
        }

        updateCartTotals(cart);
        refreshCartDrawer();
        return cart;
      })
      .catch(function () {
        setLineBusy(line, false);
      });
  }

  if (cartPageForm) {
    cartPageForm.addEventListener('change', function (e) {
      var input = e.target.closest('[data-quantity-input]');
      if (!input) return;
      var line = input.closest('[data-cart-item]');
      var key = input.getAttribute('data-key');
      var min = parseInt(input.min, 10) || 0;
      var quantity = Math.max(min, parseInt(input.value, 10) || min);
      input.value = quantity;
      changeCartLine(key, quantity, line);
    });

    cartPageForm.addEventListener('click', function (e) {
      var removeBtn = e.target.closest('[data-cart-remove]');
      if (!removeBtn) return;
      e.preventDefault();
      var line = removeBtn.closest('[data-cart-item]');
      var key = removeBtn.getAttribute('data-key');
      changeCartLine(key, 0, line);
    });

    initQuantitySelectors(cartPageForm);
  }

  /* ---------- Product gallery ---------- */
  qsa('[data-product-gallery]').forEach(function (gallery) {
    var slides = qsa('.product-gallery__slide', gallery);
    var thumbs = qsa('[data-thumb]', gallery);
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var index = thumb.getAttribute('data-index');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-index') === index); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });
  });

  /* ---------- Sticky header shadow on scroll ---------- */
  var header = qs('[data-header]');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.style.boxShadow = y > 4 ? '0 1px 0 rgba(255,255,255,.04)' : 'none';
      lastScroll = y;
    }, { passive: true });
  }
})();
